import {defineMessages} from 'react-intl';

export default defineMessages({
	sizeGuide: {
		id: 'flyouts.sizeGuideFlyout.sizeGuideButton.sizeGuide',
		defaultMessage: 'Size Guide',
	},
	sizeFit: {
		id: 'flyouts.sizeGuideFlyout.sizeGuideButton.sizeFit',
		defaultMessage: 'Size & Fit',
	},
});
